import { gql, TypedDocumentNode, useQuery } from '@apollo/client';
import { usePublicEkardoClient } from '@/components/Providers/ApolloClientsProvider';
import { environmentVariables } from '@/utils/environmentVariables';

export type PublicActivity = {
  id: number;
  title: string;
  description: string;
  url: string;
  contentType: string;
  type: string;
  status: string;
  sort: number;
  estimatedTime: string;
  created: string;
  lastUpdate: string;
  iconAsset: {
    id: string;
    presignedUrl: string;
  } | null;
  tags: Array<{
    id: number;
    name: string;
    sort: number;
  }>;
  contentPages: Array<{
    id: number;
    title: string;
    url: string;
    status: string;
  }>;
};

type GetPublicActivitiesResponse = {
  contentGroup: {
    searchContentGroups: PublicActivity[];
  };
};

type GetPublicActivitiesVariables = {
  projectId: string;
};

const GET_PUBLIC_ACTIVITIES: TypedDocumentNode<GetPublicActivitiesResponse, GetPublicActivitiesVariables> = gql`
  query GetPublicActivities($projectId: String!) {
    contentGroup {
      searchContentGroups(
        projectId: $projectId
        type: [ACTIVITY]
        contentType: [PUBLIC]
      ) {
        id
        title
        description
        url
        contentType
        type
        status
        sort
        estimatedTime
        created
        lastUpdate
        iconAsset {
          id
          presignedUrl
        }
        tags {
          id
          name
          sort
        }
        contentPages {
          id
          title
          url
          status
        }
      }
    }
  }
`;

export default function useGetPublicExercises() {
  const client = usePublicEkardoClient();

  return useQuery<GetPublicActivitiesResponse, GetPublicActivitiesVariables>(GET_PUBLIC_ACTIVITIES, {
    client,
    fetchPolicy: 'cache-first',
    variables: {
      projectId: environmentVariables.projectId,
    },
  });
}
